import axios from 'axios';
import Config from '../../../config';

export function setLanguages() {
    return async (dispatch) => {
        const language = await axios.get(Config.api.endpoint + 'api/Language', Config.getApiConfig());

        dispatch({
            type: 'SET_LANGUAGES',
            payload: {
                languages: language.data,
            }
        });

        return Promise.resolve({
            languages: language.data
        });
    }
}

export function setLanguage(language) {

    return (dispatch) => {
        dispatch({
            type: 'SET_LANGUAGE',
            payload: {
                language: language
            }
        });

        return Promise.resolve(true);
    }
}

export function getLanguageOverview(contentType = 1) {
    return (dispatch) => {
        dispatch({
            type: 'LANGUAGE_OVERVIEW_LOADING',
        });

        return axios.get(Config.api.endpoint + 'api/Language/Overview/' + contentType, Config.getApiConfig()).then(response => {
            if (response.data) {
                dispatch({
                    type: 'LANGUAGE_OVERVIEW_SUCCESS',
                    payload: {
                        data: response.data
                    }
                });

                return response;
            }
        })
    }
}


// WEBPACK FOOTER //
// ./src/core/admin/store/actions/language.js